import { computeDistanceBetween } from 'spherical-geometry-js';
/**
 * Converts milliseconds to seconds with 3 decimal places.
 * @param {number} milliseconds - The time in milliseconds.
 * @returns {number} - The time in seconds with 3 decimal places.
 */
export var convertMillisecondsToSeconds = function (milliseconds) {
    return parseFloat((milliseconds / 1000).toFixed(3));
};
/**
 * Converts a language model object to a select input option.
 * @param object
 * @returns
 */
export var convertToSelectInputOption = function (object) {
    return {
        value: object.value,
        label: object === null || object === void 0 ? void 0 : object.label,
    };
};
/**
 * Converts an array of language model objects to an array of select input options.
 * @param objects
 * @returns
 */
export var convertToSelectInputOptions = function (objects) {
    return objects.map(convertToSelectInputOption);
};
/**
 * Converts a number (even if it's null) to a google.maps.LatLngLiteral.
 * @param {number | null} lat - The latitude.
 * @param {number | null} lng - The longitude.
 * @returns {google.maps.LatLngLiteral} - The LatLngLiteral object.
 */
export var toLatLngLiteral = function (lat, lng) {
    return {
        lat: lat !== null && lat !== void 0 ? lat : 0, // Default to 0 if lat is null
        lng: lng !== null && lng !== void 0 ? lng : 0, // Default to 0 if lng is null
    };
};
/**
 * Trims any leading or trailing spaces from the given text and checks if the resulting text is not empty.
 * @param {string} text - The text to trim and check.
 * @returns {boolean} - Returns true if the trimmed text is not empty, otherwise false.
 */
export var isEmpty = function (text) {
    return text.trim().length <= 0;
};
/**
 * Converts miles to meters.
 * @param {number} miles - The distance in miles.
 * @returns {number} - The distance in meters.
 */
export var milesToMeters = function (miles) {
    return miles * 1609.34;
};
/**
 * Calculates the distance between two coordinates using the Google Maps API and returns the distance in miles.
 * @param {object} coord1 - The first coordinate with latitude and longitude.
 * @param {object} coord2 - The second coordinate with latitude and longitude.
 * @returns {number} - The distance between the two coordinates in miles, formatted to 2 decimal places.
 */
export var getDistanceInMiles = function (coord1, coord2) {
    var point1 = new google.maps.LatLng(coord1);
    var point2 = new google.maps.LatLng(coord2);
    var distanceInMeters = computeDistanceBetween(point1, point2);
    var distanceInMiles = distanceInMeters / 1609.34;
    return parseFloat(distanceInMiles.toFixed(2));
};
/**
 * Sorts an array of IPlace objects by their distance value, smallest to largest.
 * @param {IPlace[]} places - The array of IPlace objects to sort.
 * @returns {IPlace[]} - The sorted array of IPlace objects.
 */
export var sortPlacesByDistance = function (places) {
    if (!places)
        return [];
    return places.sort(function (a, b) { return a.distance - b.distance; });
};
/**
 * Debounces a function to prevent it from being called too frequently.
 * @param {Function} func - The function to debounce.
 * @param {number} delay - The time to wait before calling the function.
 * @returns {Function} - The debounced function.
 */
export function debounce(func, delay) {
    var timeout;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        clearTimeout(timeout);
        timeout = setTimeout(function () { return func.apply(void 0, args); }, delay);
    };
}
export var generateRandomId = function (length) {
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var result = '';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
};
export var getUserId = function () {
    // Generate a random number
    var randomNum = Math.floor(Math.random() * 1000000); // Adjust the range as needed
    // Combine the UTC timestamp and random number to create a unique ID
    var userId = randomNum.toString();
    return userId;
};
export var generateMapSessionCode = function () {
    return Math.random().toString(36).substring(3, 8).toUpperCase();
};
